import { Features, hasFeature } from '@ardoq/features';

export const isUseNewGrouping = (useNewGrouping: boolean) =>
  hasFeature(Features.GROUPING_RESEARCH) && useNewGrouping;
